import React from 'react';
import compact from 'lodash/compact';
import { DropdownMenu, TableList, TableListActions, Typography } from 'seagull';
import { CopyFill, TrashLine } from 'seagull/icons';
import { ServiceRowPrice } from "./ServiceRowPrice/ServiceRowPrice";
import { ServiceRowName } from "./ServiceRowName";
import { serviceTemplateModel } from "../../models";
import { recurrencePeriodLabels } from "../../constants";
export function ServiceRow(_ref) {
  var _qboItemsById$service;
  let {
    service,
    qboItemsById,
    serviceNameValidation,
    onInlineEdit,
    onEdit,
    onDuplicate,
    onDelete,
    onInputFocus,
    onInputBlur
  } = _ref;
  return /*#__PURE__*/React.createElement(TableList.Row, {
    "data-testid": "service-library-row",
    rowId: service.id,
    actionColumn: /*#__PURE__*/React.createElement(TableListActions, {
      buttonText: "Edit",
      testId: "service-library-row-actions",
      onClickButton: onEdit
    }, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      iconStart: /*#__PURE__*/React.createElement(CopyFill, null),
      "data-testid": "service-library-row-duplicate",
      onClick: onDuplicate
    }, "Duplicate"), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      skin: "error",
      iconStart: /*#__PURE__*/React.createElement(TrashLine, null),
      "data-testid": "service-library-row-delete",
      onClick: onDelete
    }, "Delete")),
    items: compact([{
      value: /*#__PURE__*/React.createElement(ServiceRowName, {
        onInputFocus: onInputFocus,
        onInputBlur: onInputBlur,
        service: service,
        serviceNameValidation: serviceNameValidation,
        onInlineEdit: onInlineEdit,
        qboServiceDisplay: service.integratedId && ((_qboItemsById$service = qboItemsById[service.integratedId]) === null || _qboItemsById$service === void 0 ? void 0 : _qboItemsById$service.name)
      })
    }, {
      value: /*#__PURE__*/React.createElement(ServiceRowPrice, {
        service: service,
        onInlineEdit: onInlineEdit,
        onInputFocus: onInputFocus,
        onInputBlur: onInputBlur
      })
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        skin: "secondary"
      }, serviceTemplateModel.isRecurring(service.billing) ? recurrencePeriodLabels[service.billing.recurrencePeriod] : 'One-time')
    }, {
      value: /*#__PURE__*/React.createElement(Typography, {
        skin: "secondary"
      }, serviceTemplateModel.isManual(service.billing) ? 'Manual' : 'Automatic')
    }])
  });
}